export default "__VITE_PUBLIC_ASSET__44b38c6b__"